import { render, staticRenderFns } from "./ModalSelectSubPatient.vue?vue&type=template&id=a73631fe&scoped=true"
import script from "./ModalSelectSubPatient.vue?vue&type=script&lang=js"
export * from "./ModalSelectSubPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73631fe",
  null
  
)

export default component.exports